import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
import {
  GoogleAuthProvider,
  getAuth,
  signInWithPopup,
  signOut,
} from "firebase/auth";
import {
  getFirestore,
  getDocs,
  collection,
  doc,
  addDoc,
  deleteDoc
} from "firebase/firestore";
import { getStorage, ref, getDownloadURL, uploadBytes } from "firebase/storage";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: "uzomadrawsss.firebaseapp.com",
  projectId: "uzomadrawsss",
  storageBucket: "uzomadrawsss.appspot.com",
  messagingSenderId: "665545056548",
  appId: "1:665545056548:web:a65d5571b29af3fbc3d3b1",
  measurementId: "G-SD9N7Q8FHR",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

const googleProvider = new GoogleAuthProvider();

async function signInWithGoogle() {
  try {
    const res = await signInWithPopup(auth, googleProvider);
    // const user = res.user;
  } catch (err) {
    console.error(err);
    alert(err.message);
  }
}

function logout() {
  signOut(auth);
}

async function uploadImageToFirebase(file) {
  const storageRef = ref(storage, `art/${file.name}`);
  let urll = await uploadBytes(storageRef, file).then((snapshot) => {
    return getDownloadURL(snapshot.ref).then((url) => {
      return url;
    });
  });

  return urll;
}

async function recordArt(name, desc, imgUrl, sectionName) {
  try {
    let id = Math.random().toString(16).slice(2);
    let timeStamp = new Date().getTime();
    

    await addDoc(collection(db, "arts"), {
      id: id,
      name: name,
      description: desc,
      imageUrl: imgUrl,
      section: sectionName,
      timeStamp: timeStamp
    });
  } catch (error) {
    console.error(error);
  }
}

async function deleteArt(artId) {
  const taskDocRef = doc(db, 'arts', artId)
  try{
    await deleteDoc(taskDocRef)
  } catch (error) {
    console.error(error);
  }
}

async function uploadArt(e, name, desc, sectionName, setUploadStatus) {
  e.preventDefault();
  let file = e.target[0]?.files[0];

  if (!file) {
    alert("Upload Image File");
  } else {
    setUploadStatus("Uploading Art");
    //first upload image
    let imgUrl = await uploadImageToFirebase(file);
    //record art
    await recordArt(name, desc, imgUrl, sectionName);
    setUploadStatus("Uploaded Yayy!");
  }
}

async function retrieveAllArt(setArtProjects) {
  const q = collection(db, "arts");
  const ordersQuerySnapshot = await getDocs(q);

  let array = ordersQuerySnapshot.docs.map((doc) => {
    return {
      mainId: doc.id,
      data: doc.data()
    };
  });

  setArtProjects(array);
}

export { auth, db, signInWithGoogle, logout, uploadArt, retrieveAllArt, deleteArt };
